import { DomBoardView } from "./dom-board-view.js";

export class BoardHost {
  constructor(callbacks) {
    this.callbacks = callbacks;
    this.container = null;
    this.state = null;
    this.mode = "2d";
    this.view = this.#createDomView();
    this.switchSequence = 0;
  }

  attach(container) {
    this.container = container;
    this.view.mount(container);
    if (this.state) {
      this.view.update(this.state);
    }
  }

  detach() {
    this.view.element.remove();
    this.container = null;
  }

  update(state) {
    this.state = state;
    this.view.update(state);
  }

  focusSquare(square) {
    this.view.focusSquare(square);
  }

  animateMove(move, options) {
    return this.view.animateMove(move, options);
  }

  async switchMode(mode) {
    if (mode === this.mode) {
      return { ok: true, mode };
    }
    const sequence = ++this.switchSequence;
    let next;
    try {
      if (mode === "3d") {
        if (!supportsWebGl2()) {
          throw new Error("WebGL 2 is not available on this device.");
        }
        const { ThreeBoardView } = await import("./three-board-view.js");
        next = new ThreeBoardView(this.callbacks);
        await next.initialize();
      } else {
        next = this.#createDomView();
      }
      if (sequence !== this.switchSequence) {
        next.dispose();
        return { ok: false, cancelled: true };
      }
      const previous = this.view;
      this.view = next;
      this.mode = mode;
      if (this.container) {
        next.mount(this.container);
      }
      if (this.state) {
        next.update(this.state);
      }
      previous.dispose();
      return { ok: true, mode };
    } catch (error) {
      next?.dispose?.();
      return { ok: false, error };
    }
  }

  dispose() {
    this.switchSequence += 1;
    this.view.dispose();
    this.container = null;
  }

  #createDomView() {
    return new DomBoardView(this.callbacks);
  }
}

export function supportsWebGl2() {
  try {
    const canvas = document.createElement("canvas");
    const context = canvas.getContext("webgl2", {
      failIfMajorPerformanceCaveat: true,
    });
    context?.getExtension("WEBGL_lose_context")?.loseContext();
    return Boolean(context);
  } catch {
    return false;
  }
}
